const LOCAL_HISTORY_LIMIT = 50;

function joinVisible(parts = [], separator = ' - ') {
  return parts.map(part => String(part || '').trim()).filter(Boolean).join(separator);
}

function addressComponent(place = {}, types = []) {
  const components = place?.address_components || [];
  const found = components.find(component => types.some(type => component.types?.includes(type)));
  return found?.long_name || found?.short_name || '';
}

function addressComponentShort(place = {}, types = []) {
  const components = place?.address_components || [];
  const found = components.find(component => types.some(type => component.types?.includes(type)));
  return found?.short_name || found?.long_name || '';
}

function parseLegacyAddress(address = '') {
  const text = String(address || '').trim();
  if (!text) return { street: '', locality: '' };
  const [streetRaw, ...rest] = text.split(/\s+-\s+/).map(part => part.trim()).filter(Boolean);
  if (!rest.length) return { street: text, locality: '' };
  const cleanRest = rest.join(' - ')
    .replace(/,?\s*Brasil$/i, '')
    .replace(/,?\s*Brazil$/i, '')
    .replace(/,?\s*\d{5}-?\d{3}.*$/i, '')
    .trim();
  const localityParts = cleanRest.split(/\s+-\s+|,\s*/).map(part => part.trim()).filter(Boolean);
  return { street: streetRaw || text, locality: joinVisible(localityParts.slice(0, 3)) };
}

export function publicFamilyAddressParts(formOrItem = {}) {
  const place = formOrItem.endereco_place || formOrItem.address_place || {};
  const route = addressComponent(place, ['route']);
  const number = addressComponent(place, ['street_number']);
  const neighborhood = addressComponent(place, ['sublocality_level_1', 'sublocality_level_2', 'sublocality', 'neighborhood', 'administrative_area_level_4']);
  const city = addressComponent(place, ['administrative_area_level_2', 'locality']);
  const state = addressComponentShort(place, ['administrative_area_level_1']);
  const parsed = parseLegacyAddress(formOrItem.endereco || formOrItem.address || '');
  return {
    street: formOrItem.address_street || joinVisible([route, number], ', ') || parsed.street,
    locality: formOrItem.address_locality || joinVisible([neighborhood, city, state]) || parsed.locality,
  };
}

export function publicFamilyHistoryStorageKey(token) {
  return `movimentos:familias-publicas:${token}:historico`;
}

export function readPublicFamilyHistory(token) {
  if (typeof window === 'undefined') return [];
  try {
    const raw = window.localStorage.getItem(publicFamilyHistoryStorageKey(token));
    const parsed = raw ? JSON.parse(raw) : [];
    return Array.isArray(parsed) ? parsed.filter(item => item && typeof item === 'object') : [];
  } catch {
    return [];
  }
}

export function savePublicFamilyHistory(token, items) {
  if (typeof window === 'undefined') return;
  try {
    window.localStorage.setItem(publicFamilyHistoryStorageKey(token), JSON.stringify(items.slice(0, LOCAL_HISTORY_LIMIT)));
  } catch (error) {
    console.warn('Não foi possível salvar histórico local do cadastro público', error);
  }
}

export function buildPublicFamilyHistoryItem(form, selectedChurch, familyId) {
  const names = (form.pessoas || []).map(person => (person.nome || '').trim()).filter(Boolean);
  const addressParts = publicFamilyAddressParts(form);
  return {
    id: familyId || `local_${Date.now()}`,
    submitted_at: new Date().toISOString(),
    names,
    church_name: selectedChurch?.name || '',
    address: form.endereco || '',
    address_street: addressParts.street,
    address_locality: addressParts.locality,
    address_place: form.endereco_place || null,
  };
}

export function formatPublicFamilyHistoryDateTime(value) {
  if (!value) return '-';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return '-';
  return date.toLocaleString('pt-BR', { dateStyle: 'short', timeStyle: 'short', timeZone: 'America/Sao_Paulo' });
}